module.exports = __webpack_public_path__ + "img/12.d2fa0937.png";